export class CreateSqlEngineInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "workerCount",
            "baseName": "workerCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "workerSize",
            "baseName": "workerSize",
            "type": "CreateSqlEngineInputWorkerSizeEnum",
            "format": ""
        },
        {
            "name": "autoscaling",
            "baseName": "autoscaling",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "minWorkers",
            "baseName": "minWorkers",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxWorkers",
            "baseName": "maxWorkers",
            "type": "number",
            "format": ""
        },
        {
            "name": "idleTimeoutMinutes",
            "baseName": "idleTimeoutMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "awsRuntimeConfig",
            "baseName": "awsRuntimeConfig",
            "type": "AwsRuntimeConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateSqlEngineInput.attributeTypeMap;
    }
    constructor() {
    }
}
export var CreateSqlEngineInputWorkerSizeEnum;
(function (CreateSqlEngineInputWorkerSizeEnum) {
    CreateSqlEngineInputWorkerSizeEnum["Xs"] = "xs";
    CreateSqlEngineInputWorkerSizeEnum["Small"] = "small";
    CreateSqlEngineInputWorkerSizeEnum["Medium"] = "medium";
    CreateSqlEngineInputWorkerSizeEnum["Large"] = "large";
    CreateSqlEngineInputWorkerSizeEnum["Xl"] = "xl";
})(CreateSqlEngineInputWorkerSizeEnum || (CreateSqlEngineInputWorkerSizeEnum = {}));
